<template>
  <WeContainer card="">
    <div class="card">
      <div class="card-header pt-4 pb-4 custom-header-bg">
        <h5 class="font-weight-bold mb-0 text-danger">
          <span class="text-uppercase">SİLİNEN MARKA TİPLERİ</span>
        </h5>
      </div>
      <div class="card-body position-relative" style="min-height: 200px">
        <WeTable
          v-if="ready"
          v-bind:index="false"
          v-bind:data.sync="brandType.list"
          v-bind:columns="columns"
          v-bind:actions="tableActions"
          v-on:on-action="onAction"
        ></WeTable>
        <WeLoading v-else />
      </div>
    </div>
  </WeContainer>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "Trash",
  data() {
    return {
      ready: false,
      tableActions: [
        {
          icon: "fas fa-sync fa-sm",
          class: "btn-outline-primary",
          action: "restore",
          tooltip: "Geri Al",
        },
        {
          icon: "fas fa-trash fa-sm",
          class: "btn-outline-danger ml-2",
          action: "remove",
          tooltip: "Kalıcı Olarak Sil",
        },
      ],
      columns: [
        { name: "name", th: "Tip Adı", type: "string" },
        { name: "description", th: "Açıklama", type: "string" },
        { name: "is_active", th: "Durum", type: "boolean", width: "10%" },
        { name: "locales", th: "Dil", type: "language" },
      ],
    };
  },
  methods: {
    ...mapActions("brandType", ["getList", "restore", "remove"]),
    onAction(data) {
      if (data.key == "remove") {
        this.onRemove(data.row, data.index);
      } else if (data.key == "restore") {
        this.onRestore(data.row, data.index);
      }
    },
    onRestore(row, index) {
      let message = `${row.name} adlı marka tipini geri almak istediğinize emin misiniz ?`;
      this.$swal({
        title: message,
        icon: "question",
        showCancelButton: true,
        cancelButtonText: "İptal",
        confirmButtonText: "Geri Al",
      }).then((confirm) => {
        if (confirm.isConfirmed) {
          const checkPermission = this.checkPermission("r");
          if (!checkPermission) {
            permission.alert(this);
          } else {
            this.restore({
              id: row.id,
              onSuccess: (result) => {
                if (result && result.data && result.data.status !== "error") {
                  this.$toast.success("Marka Tipi Başarıyla Geri Alındı");
                  this.brand.list.splice(index, 1);
                } else {
                  this.$swal({
                    title: "Marka Tipi Geri Alınamadı",
                    text: result.data.message,
                    icon: "error",
                    confirmButtonText: "Tamam",
                  });
                }
              },
            });
          }
        }
      });
    },
    onRemove(row, index) {
      let message = `${row.name} marka tipini kalıcı olarak silmek istediğinize emin misiniz ?`;
      this.$swal({
        title: message,
        text: "Bu işlem geri alınamaz.",
        icon: "question",
        showCancelButton: true,
        cancelButtonText: "İptal",
        confirmButtonText: "Sil",
      }).then((confirm) => {
        if (confirm.isConfirmed) {
          const checkPermission = this.checkPermission("f");
          if (!checkPermission) {
            permission.alert(this);
          } else {
            this.remove({
              id: row.id,
              onSuccess: (result) => {
                if (result && result.data && result.data.status !== "error") {
                  this.$toast.success("Marka Başarıyla Silindi");
                  this.brand.list.splice(index, 1);
                } else {
                  this.$swal({
                    title: "Marka Tipi Silinemedi",
                    text: result.data.message,
                    icon: "error",
                    confirmButtonText: "Tamam",
                  });
                }
              },
            });
          }
        }
      });
    },
    getAll() {
      this.ready = false;
      this.getList({
        id: this.$route.params.id,
        deleted: true,
        onSuccess: () => {
          this.ready = true;
        },
      });
    },
    checkPermission(code) {
      return permission.check("brand", code);
    },
  },
  computed: {
    ...mapState(["brandType", "shared"]),
  },
  mounted() {
    this.getAll();
  },
};
</script>
